module.exports = __webpack_public_path__ + "img/perforaciones_9-16.3ed14657.webp";